import { render, staticRenderFns } from "./AdminWorkPlace.vue?vue&type=template&id=41de395e&scoped=true"
import script from "./AdminWorkPlace.vue?vue&type=script&lang=js"
export * from "./AdminWorkPlace.vue?vue&type=script&lang=js"
import style0 from "./AdminWorkPlace.vue?vue&type=style&index=0&id=41de395e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41de395e",
  null
  
)

export default component.exports